<template>
  <div class="bg-white px-3 index wrap">
    <!-- <div class="wrap_btn">
      <el-button type="primary" @click="conditionshow" v-if="conditionshows" size="mini">精确查找<i
          class="el-icon-bottom el-icon--right"></i></el-button>
      <el-button type="success" @click="conditionshow" v-else size="mini">收起<i class="el-icon-top el-icon--right"></i>
      </el-button>
    </div> -->
    <el-form ref="form" :model="sizeForm" label-width="80px">
      <el-form-item label="会员等级" style="margin-bottom: 0px">
        <el-radio-group v-model="sizeForm.vip" size="mini">
          <el-radio-button label="不限"></el-radio-button>
          <el-radio-button label="正象银卡"></el-radio-button>
          <el-radio-button label="正象金卡"></el-radio-button>
          <el-radio-button label="正象白金卡"></el-radio-button>
          <el-radio-button label="正象钻石卡"></el-radio-button>
          <el-radio-button label="正象黑卡"></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="注册日期" style="margin-top: -15px; margin-bottom: 0px">
        <el-date-picker v-model="sizeForm.timer" size="mini" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-show="conditionshows2" label="用户标签" style="margin-top: -15px; margin-bottom: 0px">
        <el-select v-model="sizeForm.labels" placeholder="请选择" size="mini" clearable>
          <el-option v-for="item in labeloptions" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户类型" style="margin-top: -15px; margin-bottom: 0px">
        <el-select v-model="sizeForm.customer_type" placeholder="请选择" size="mini" clearable>
          <el-option label="普通用户" :value="1"></el-option>
          <el-option label="医生" :value="2"></el-option>
          <el-option label="达人" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="conditionshows2" label="精确查询" style="margin-top: -15px; margin-bottom: 0px">
        <el-select v-model="sizeForm.value" placeholder="请选择" size="mini">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="sizeForm.input" placeholder="请输入内容" size="mini" style="width: 200px; margin-left: 10px">
        </el-input>
      </el-form-item>
    </el-form>
    <div>
      <el-button type="success" size="mini" @click="searchEvent">查询</el-button>
      <el-button type="primary" size="mini" @click="getuser" :loading="updatelistloading">更新用户缓存列表</el-button>
      <el-button type="info" plain size="mini" @click="pushxx('')">批量推送消息</el-button>
      <el-dropdown trigger="click" style="margin-left:10px">
        <el-button type="primary" size="mini">
          分配操作<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item><span @click="distribution(2)">选中分配</span> </el-dropdown-item>
          <el-dropdown-item><span @click="distribution(1)">全量分配</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- <button-search
      class="pt-3"
      placeholder="手机号/邮箱/会员昵称"
      @search="searchEvent"
    >
      <template #left>
        <el-button
          type="primary"
          size="mini"
          @click="getuser"
          :loading="updatelistloading"
          >更新用户缓存列表</el-button
        >
        <el-button type="info" plain size="mini" @click="pushxx('')"
          >批量推送消息</el-button
        >
      </template>
      <template #form>
        <el-form inline ref="form" :model="search" label-width="80px">
          <el-form-item label="搜索内容" class="mb-0">
            <el-input
              v-model="search.keyword"
              placeholder="手机号/邮箱/会员昵称"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员等级" class="mb-0">
            <el-select
              v-model="search.user_level_id"
              size="mini"
              placeholder="请选择会员等级"
            >
              <el-option
                v-for="(item, index) in user_level"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否注册" class="mb-0">
            <el-select
              v-model="search.is_register"
              size="mini"
              placeholder="请选择"
              clearable
            >
              <el-option label="未注册" value="2"></el-option>
              <el-option label="已注册" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">
              搜索</el-button
            >
            <el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
          </el-form-item>
        </el-form>
      </template>
    </button-search> -->

    <el-table border class="mt-3" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"
      ref="configurationTables" :row-key="getRowKeys" :height="heights">
      <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
      <el-table-column prop="id" label="用户ID" width="100" align="center">
      </el-table-column>
      <el-table-column width="280" label="用户" align="center">
        <template slot-scope="scope">
          <div class="media">
            <img class="mr-3 rounded-circle" v-if="scope.row.avatar" :src="scope.row.avatar"
              style="width: 40px; height: 40px" />
            <div class="media-body">
              <h6 class="mt-0 d-flex align-items-center">
                <el-button type="text" @click="openlaiyuan(scope.row)">{{ scope.row.nickname }}
                </el-button>
              </h6>
              <!-- 用户id：{{scope.row.id}} -->
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="会员等级">
				<template slot-scope="scope">
					{{scope.row.user_level?scope.row.user_level.name:''  }}
				</template>
			</el-table-column> -->
      <el-table-column prop="phone" label="电话" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="receiving_number" label="收货电话" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="levelName" label="会员等级" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="kcurrency" label="积分" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="用户标签" align="center" show-overflow-tooltip :formatter="formatData" prop="label_name">
      </el-table-column>
      <el-table-column prop="create_time" label="注册时间" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="last_login" align="center" label="最后登录" show-overflow-tooltip>
        <!-- <template slot-scope="scope" >
					<div>注册时间 : {{scope.row.create_time}}</div>
					<div>最后登录 : {{scope.row.last_login}}</div>
				</template> -->
      </el-table-column>
      <el-table-column prop="status" align="center" label="状态" width="80">
        <template slot-scope="scope">
          <el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>
            {{ scope.row.status ? "启用" : "禁用" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="userdetails(scope.row)">用户详情</el-button>
          <!-- <el-button type="text" size="mini">编辑标签</el-button>
          <el-button type="text" size="mini" @click="familydangan(scope.row)">家庭档案</el-button>
          <el-button type="text" size="mini" @click="openguiji(scope.row)">行为轨迹</el-button>
          <el-button type="text" size="mini" @click="openModel(scope)">查看档案</el-button>
          <el-button type="text" size="mini" @click="openaddressModel(scope.row)">查看收货地址</el-button>
          <el-button type="text" size="mini" @click="deleteItem(scope.row)">删除</el-button> -->

          <el-dropdown trigger="click" style="margin-left:10px">
            <span class="el-dropdown-link">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><span @click="familydangan(scope.row)">家庭档案</span> </el-dropdown-item>
              <el-dropdown-item><span @click="openguiji(scope.row)">行为轨迹</span></el-dropdown-item>
              <el-dropdown-item><span @click="openModel(scope)">查看档案</span></el-dropdown-item>
              <el-dropdown-item><span @click="openaddressModel(scope.row)">查看收货地址</span></el-dropdown-item>
              <el-dropdown-item divided>编辑标签</el-dropdown-item>

              <el-dropdown-item divided><span @click="pushxx(scope.row)">推送消息</span></el-dropdown-item>
              <el-dropdown-item><span @click="pushsx(scope.row)">私信消息</span></el-dropdown-item>
              <el-dropdown-item divided><span style="color:red" @click="deleteItem(scope.row)">删除</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div style="height: 60px"></div> -->
    <!-- <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white"
      style="bottom: 0; left: 200px; right: 0; z-index: 100"> -->
    <div class="u-f u-ac u-jsb ft_mr">
      <div></div>
      <el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <!-- </el-footer> -->
    <!-- 新增/修改模态框 -->
    <el-dialog title="用户档案" :visible.sync="createModel" top="5vh">
      <!-- 表单内容 -->
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="用户名" size="mini" style="width: 25%"></el-input>
        </el-form-item>
        <!-- <el-form-item label="密码" prop="password">
					<el-input v-model="form.password" placeholder="密码" size="mini" style="width: 25%;"></el-input>
				</el-form-item> -->
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="form.nickname" placeholder="昵称" size="mini" style="width: 25%"></el-input>
        </el-form-item>
        <el-form-item label="头像">
          <span v-if="!form.avatar" class="btn btn-light border mr-2" @click="chooseImage">
            <i class="el-icon-plus"></i>
          </span>
          <img v-else :src="form.avatar" class="rounded" style="width: 45px; height: 45px; cursor: pointer"
            @click="chooseImage" />
        </el-form-item>
        <el-form-item label="会员等级">
          <el-select v-model="form.user_level_id" placeholder="请选择会员等级" size="mini">
            <el-option v-for="(item, index) in user_level" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户类别">
          <el-select v-model="form.user_type_id" placeholder="请选择用户类别" size="mini">
            <el-option v-for="(item, index) in user_type" :key="index" :label="item.content_name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生" v-if="form.user_type_id == 197">
          <el-select v-model="form.relation_doctor_id" multiple collapse-tags size="mini" placeholder="请选择医生">
            <el-option v-for="(item, index) in doc_options" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <template v-if="form.user_type_id == 288">
          <el-form-item label="客服头像">
            <div>
              <span v-if="form.cs_avatar == ''" class="btn btn-light border mr-2" @click="chooseImage(2)">
                <i class="el-icon-plus"></i>
              </span>
              <img v-else :src="form.cs_avatar" class="rounded" style="width: 45px; height: 45px; cursor: pointer"
                @click="chooseImage(2)" />
            </div>
          </el-form-item>
          <el-form-item label="客服昵称">
            <el-input v-model="form.cs_name" placeholder="客服昵称" size="mini" style="width: 25%"></el-input>
          </el-form-item>
        </template>

        <el-form-item label="手机" prop="phone">
          <el-input v-model="form.phone" placeholder="手机" size="mini" style="width: 25%"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="邮箱" size="mini" style="width: 25%"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status" size="mini">
            <el-radio :label="1" border>启用</el-radio>
            <el-radio :label="0" border>禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="createModel = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 收货地址 -->
    <el-dialog title="收货地址" :visible.sync="shouaddressModel" top="150px">
      <div class="outbox" v-loading="addressloading">
        <div class="itembox">
          <div v-for="(v, i) in addressdata" :key="i" class="items">
            {{ v.name }}--{{ v.phone }}--{{ v.province }}{{ v.city
            }}{{ v.district }}{{ v.address }}
          </div>
          <el-empty v-if="addressdata.length == 0" description="空的！"></el-empty>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="shouaddressModel = false">取 消</el-button>
        <el-button type="primary" @click="shouaddressModel = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 推送信息 -->
    <el-dialog title="推送消息" :visible.sync="pushModel" top="150px">
      <div class="outbox2">
        <el-row>
          <el-col :span="12">
            <div class="sl_tits">模板示例</div>
            <div class="sl_out_b">
              <div class="sl_boxx">
                <div class="conss">
                  <p>您好，您的以下合同有新的服务指引送达</p>
                  <p>申请人姓名∶赵五</p>
                  <p>服务名称︰美国留学合同</p>
                  <p>请点击查看详细的服务指引文件</p>
                </div>
                <div class="xq">
                  <div>详情</div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form ref="pushform" :model="pushform" label-width="100px">
                <el-form-item label="用户类型" v-if="pushtype > 1">
                  <el-select v-model="pushform.type" placeholder="请选择" size="small" @change="changetype">
                    <el-option label="未注册" :value="3"></el-option>
                    <el-option label="注册" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input v-model="pushform.first" placeholder="头部内容" size="mini" style="width: 80%">
                  </el-input>
                </el-form-item>
                <el-form-item label="申请人姓名">
                  <el-input v-model="pushform.keyword1" placeholder="申请人姓名" size="mini" style="width: 80%">
                  </el-input>
                </el-form-item>
                <el-form-item label="服务名称">
                  <el-input v-model="pushform.keyword2" placeholder="服务名称" size="mini" style="width: 80%">
                  </el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input v-model="pushform.remark" placeholder="内容" size="mini" style="width: 80%">
                  </el-input>
                </el-form-item>
                <el-form-item label="链接地址">
                  <el-input v-model="pushform.url" placeholder="链接地址" size="mini" style="width: 80%">
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pushModel = false">取 消</el-button>
        <el-button type="primary" :loading="pushloading" @click="pushH">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="公众号列表" :visible.sync="gzhlistModel" top="100px" width="60%" class="dialogs">
      <el-divider></el-divider>
      <el-table border class="mt-3" :data="gzhtableData" style="width: 100%" :height="gzhtabheight"
        v-loading="gzhlistloading">
        <el-table-column prop="gzhStr" label="公众号名称" align="center">
        </el-table-column>
        <el-table-column prop="subscribe_time" label="关注时间" align="center">
        </el-table-column>
        <el-table-column prop="gzhStr" label="是否关注" align="center">
          <template slot-scope="{ row }">
            {{ { 0: "未关注", 1: "已关注" }[row.subscribe] }}
          </template>
        </el-table-column>
        <el-table-column label="账号信息" align="center">
          <template slot-scope="scope">
            <div class="media u-f u-ac">
              <img class="mr-3 rounded-circle" v-if="scope.row.headimgurl" :src="scope.row.headimgurl"
                style="width: 40px; height: 40px" />
              <div class="media-body">
                <h6 class="mt-0 d-flex align-items-center">
                  {{ scope.row.nickname }}
                </h6>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closegzhlist" size="small">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="家庭档案" :visible.sync="familyModel" top="150px">
      <el-table :data="familytableData" style="width: 100%">
        <el-table-column prop="real_name" label="咨询人姓名"> </el-table-column>
        <el-table-column prop="sex" label="性别"> </el-table-column>
        <el-table-column prop="age" label="年龄"> </el-table-column>
        <el-table-column prop="birthday_text" label="出生日期"> </el-table-column>
        <el-table-column prop="province_text" label="当前城市"> </el-table-column>
        <el-table-column prop="relationship_text" label="咨询人关系(是否本人)">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码"> </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="行为轨迹" :visible.sync="guijiModel" top="150px">
      <el-form inline>
        <el-form-item label="日期">
          <el-date-picker v-model="fwtimes" size="mini" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" size="mini" @click="guijibegin">
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-printer" :loading='dcing' size="mini" @click="exportModal = true">
            导出</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="guijitableData" height="400" v-loading="loadings">
        <el-table-column prop="create_user" label="ID" align="center"></el-table-column>
        <el-table-column prop="create_time" label="时间" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="ip_province" label="省份" align="center"></el-table-column>
        <el-table-column prop="modular_id_text" label="模块" align="center"></el-table-column>
        <el-table-column prop="behavior_id_text" label="行为" align="center"></el-table-column>
        <el-table-column prop="source_url" label="来源页面" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="url" label="前往页面" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="duration" label="停留时间" align="center"></el-table-column>
        <el-table-column prop="username" label="操作人" align="center" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div class="u-f u-ac u-jsb ft_mr">
        <div></div>
        <div>
          <el-pagination @size-change="gjhandleSizeChange" @current-change="gjhandleCurrentChange"
            :current-page="gjcurrentPage" :page-sizes="[10, 30, 50, 100]" :page-size="gjpagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="gjcount">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="导出数据" :visible.sync="exportModal" width="30%" center>
      <el-form :model="exportForm" ref="ruleForm">
        <el-form-item label="时间范围" prop="time">
          <el-date-picker v-model="exportForm.time" type="date" size="small" value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportModal = false">取 消</el-button>
        <el-button type="primary" :loading='dcing' @click="exportExcel">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="分配" :visible.sync="distributionModal" width="30%" center @close='closefp'>
      <el-form :model="disForm" ref="ruleForm" label-width="100px">
        <el-form-item label="选择管理员" required>
          <el-select v-model="disForm.kf" placeholder="请选择" size="small" filterable>
            <el-option v-for="(item,index) in kfoptions" :key="index" :label="item.username" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配方式" required>
          <el-radio-group v-model="disForm.disTypeRadio">
            <el-radio :label="2">覆盖分配</el-radio>
            <el-radio :label="1">新增分配</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="color:red">*覆盖分配：替换管理员</div>
        <div style="color:red">*新增分配：分配给多个管理员</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="distributionModal = false">取 消</el-button>
        <el-button type="primary" :loading='dcing' @click="distributionFun">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import buttonSearch from "@/components/common/button-search.vue";
  import common from "@/common/mixins/common.js";
  export default {
    inject: ["app", "layout"],
    mixins: [common],
    components: {
      buttonSearch,
    },
    data() {
      return {
        familyModel: false,
        familytableData: [],
        // 轨迹
        guijiModel: false,
        gjpagesize: 10,
        gjcurrentPage: 1,
        gjcount: 0,
        guijitableData: [],
        user_value: 0,
        fwtimes: [],
        loadings: false,
        // 导出
        exportModal: false,
        dcing: false,
        exportForm: {
          time: ''
        },

        sizeForm: {
          vip: "",
          labels: "",
          timer: "",
          value: "1",
          input: "",
          customer_type: ''
        },
        options: [{
            value: "1",
            label: "用户ID",
          },
          {
            value: "2",
            label: "用户姓名",
          },
          {
            value: "3",
            label: "用户手机号",
          },
          {
            value: "4",
            label: "用户微信号",
          },
        ],
        labeloptions: [{
            value: "0",
            label: "不限",
          },
          {
            value: "1",
            label: "标签1",
          },
          {
            value: "2",
            label: "标签2",
          },
        ],
        preUrl: "user",
        tableData: [],
        createModel: false,
        editIndex: -1,
        search: {
          keyword: "",
          user_level_id: "",
          is_register: "",
        },
        form: {
          username: "",
          password: "",
          nickname: "",
          avatar: "",
          user_level_id: 1,
          user_type_id: "",
          relation_doctor_id: "",
          phone: "",
          email: "",
          status: 1,
          cs_avatar: "",
          cs_name: "",
        },
        user_level: [],
        user_type: [],
        doc_options: [],
        updatelistloading: false,
        selectusers: [],
        shouaddressModel: false,
        addressloading: false,
        addressdata: [],
        pushModel: false,
        pushform: {
          first: "",
          remark: "",
          url: "",
          keyword1: "",
          keyword2: "",
          type: 3,
        },
        pushloading: false,
        pushUserId: "",
        pushtype: 1,
        heights: null,
        gzhlistModel: false,
        gzhtableData: [],
        gzhtabheight: null,
        gzhlistloading: false,
        conditionshows: false,
        conditionshows2: true,
        disTypeRadio: '',
        kfoptions: [],
        disForm: {
          disTypeRadio: 1,
          kf: ''
        },
        distributionModal: false
      };
    },
    mounted() {
      this.getHeight();
      this.getdistributionoptions()
    },
    created() {
      this.searchTags();
    },
    methods: {
      formatData(row) {
        let rowlabel_name = (row && row.label_name) || [];
        let arr = [];
        rowlabel_name.forEach((item) => {
          //如果数据特别多的话,还可以在这里加if判断,仅展示规定的数据
          arr.push(item.name);
        });
        //
        return arr.join(",");
      },
      //搜索
      searchData() {
        /*
               sizeForm: {
                等级
            vip: "不限",
            标签
            labels: "不限",
            时间
            timer: "",

            value: "1",
            input: "",
          },
          */
        return;
        let url = this.getListUrl();
        this.axios
          .post(
            url, {
              levelName: this.sizeForm.vip,
              label_id: this.sizeForm.labels,
              search: this.sizeForm.input,
              start: this.sizeForm.timer[0],
              end: this.sizeForm.timer[1],
              limit: this.page.size,
              keyword: "",
              user_level_id: "",
              is_register: "",
              limit: this.page.size,
              page: this.page.current,
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      },
      // 获取请求列表分页url
      getListUrl() {
        return `/admin/${this.preUrl}/${this.page.current}?limit=${
        this.page.size
      }&keyword=${this.search.keyword}&customer_type=${this.sizeForm.customer_type}
      &user_level_id=${this.search.user_level_id}&is_register=${
        this.search.is_register
      }&levelName=${this.sizeForm.vip}
      &label_id=${this.sizeForm.labels}&search=${this.sizeForm.input}&start=${
        this.sizeForm.timer[0] == undefined ? "" : this.sizeForm.timer[0]
      }&end=${
        this.sizeForm.timer[1] == undefined ? "" : this.sizeForm.timer[1]
      }`;
      },
      //获取标签下拉框
      searchTags() {
        let that = this;
        axios
          .get(`/admin/user_label/1?limit=100`, {
            token: true,
          })
          .then((res) => {
            that.labeloptions = res.data.data.list;
          })
          .catch((error) => {});
      },
      conditionshow() {
        this.conditionshows = !this.conditionshows;
        this.conditionshows2 = !this.conditionshows2;
      },
      openlaiyuan(r) {
        this.gzhlistModel = true;
        this.gzhlistloading = true;
        this.axios
          .post(
            "/admin/wssadmin/wechat/userWechatList", {
              user_id: r.id,
            }, {
              token: true,
            }
          )
          .then((res) => {
            this.gzhlistloading = false;
            if (res.data.code == 200) {
              this.gzhtableData = res.data.data;
            } else {
              this.$message(res.data.msg);
            }
          });
      },
      closegzhlist() {
        this.gzhlistModel = false;
        this.gzhlistloading = false;
      },
      // 获取高度
      getHeight() {
        let that = this;
        that.heights = window.innerHeight - 350 + "px";
        that.gzhtabheight = window.innerHeight - 310 + "px";
        window.onresize = () => {
          that.heights = window.innerHeight - 350 + "px";
          that.gzhtabheight = window.innerHeight - 310 + "px";
        };
      },
      handleSelectionChange(val) {
        this.selectusers = val;
      },
      getListResult(e) {
        this.doc_options = [];
        this.tableData = e.list;
        this.user_level = e.user_level;
        this.user_type = e.user_type;
        e.doctor.forEach((element) => {
          let obj = {
            label: element.nickname,
            value: element.id,
          };
          this.doc_options.push(obj);
        });
      },

      // 打开模态框
      openModel(e = false) {
        // 增加
        if (!e) {
          // 初始化表单
          this.form = {
            username: "",
            password: "",
            nickname: "",
            avatar: "",
            user_level_id: 3,
            phone: "",
            email: "",
            status: 1,
          };
          this.editIndex = -1;
        } else {
          // 修改
          this.form = {
            username: e.row.username,
            password: "",
            nickname: e.row.nickname,
            avatar: e.row.avatar,
            user_level_id: e.row.user_level_id,
            phone: e.row.phone,
            email: e.row.email,
            status: e.row.status,
            user_type_id: e.row.user_type_id ? e.row.user_type_id : "",
            relation_doctor_id: e.row.relation_doctor_id ?
              e.row.relation_doctor_id.split(",").map(Number) : "",
            cs_avatar: e.row.cs_avatar ? e.row.cs_avatar : "",
            cs_name: e.row.cs_name ? e.row.cs_name : "",
          };
          this.editIndex = e.$index;
        }
        // 打开dialog
        this.createModel = true;
      },
      openaddressModel(r) {
        this.shouaddressModel = true;
        this.addressloading = true;
        axios
          .post(
            "/admin/pc/user/userAddresses", {
              user_id: r.id,
            }, {
              token: true,
            }
          )
          .then((res) => {
            this.addressloading = false;
            if (res.data.code == 200) {
              this.addressdata = res.data.data;
            }
          })
          .catch((err) => {
            this.addressloading = false;
            this.addressdata = [];
          });
      },
      // 添加规格
      submit() {
        let id = 0;
        if (this.form.relation_doctor_id) {
          this.form.relation_doctor_id = this.form.relation_doctor_id.toString();
        }

        if (this.editIndex !== -1) {
          id = this.tableData[this.editIndex].id;
        }
        if (this.form.user_type_id == 288 && this.form.cs_avatar == "")
          return this.$message.error("客服头像必传");
        if (this.form.user_type_id == 288 && this.form.cs_name == "")
          return this.$message.error("客服昵称必填");
        this.addOrEdit(this.form, id);
        // 关闭模态框
        this.createModel = false;
      },
      // 清空筛选条件
      clearSearch() {
        this.search = {
          keyword: "",
          user_level_id: "",
        };
      },
      // 搜索事件
      searchEvent(e = false) {
        this.page.current = 1;
        if (this.sizeForm.vip == "不限") {
          this.sizeForm.vip = "";
        }
        // 简单搜索
        if (typeof e === "string") {
          this.search.keyword = e;
          this.getList();
          return;
        }
        // 高级搜索
        this.getList();
      },
      // 选择头像
      chooseImage(t) {
        this.app.chooseImage((res) => {
          if (t != 2) {
            this.form.avatar = res[0].url;
          } else {
            this.form.cs_avatar = res[0].url;
          }
        }, 1);
      },
      async getuser() {
        this.updatelistloading = true;
        await axios
          .post(
            "/admin/User/userList", {
              page: 1,
              limit: 10000,
            }, {
              token: true,
            }
          )
          .then(async (res) => {
            this.updatelistloading = false;
            if (res.data.code == 200) {
              this.$message.success("更新成功");
              let allUserList = res.data.data.list;
              localStorage.setItem("allUserList", JSON.stringify(allUserList));
            } else {}
          })
          .catch((error) => {});
      },
      pushxx(r) {
        this.pushform = {
          first: "",
          remark: "",
          url: "",
          keyword1: "",
          keyword2: "",
          type: 3,
        };
        this.pushModel = true;
        this.pushUserId = r ? r.id : "";
        if (r) {
          this.pushtype = 1;
        } else {
          this.pushtype = this.pushform.type;
        }
      },
      changetype(i) {
        this.pushtype = i;
      },
      pushH() {
        if (this.pushform.first == "") return this.$message.error("头部内容必填");
        if (this.pushform.remark == "") return this.$message.error("内容必填");
        this.$confirm(
            `${this.pushtype == 1 ? "确认" : "确认批量"}` + "推送消息吗, 是否继续?",
            "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
          .then(() => {
            this.pushloading = true;
            axios
              .post(
                "/admin/user/messagePush", {
                  user_id: this.pushUserId,
                  type: this.pushtype,
                  first: this.pushform.first,
                  keyword1: this.pushform.keyword1,
                  keyword2: this.pushform.keyword2,
                  remark: this.pushform.remark,
                  template: 1,
                  url: this.pushform.url,
                }, {
                  token: true,
                }
              )
              .then(async (res) => {
                this.pushloading = false;
                if (res.data.code == 200) {
                  this.$message.success("推送成功");
                  this.pushModel = false;
                } else {
                  this.$message(res.msg);
                }
              })
              .catch((error) => {});
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      },
      //用户详情跳转
      userdetails(row) {
        this.$router.push({
          path: "/user/user-list/details",
          query: {
            rows: JSON.stringify(row),
          },
        });
      },
      //家庭档案跳转
      familydangan(row) {
        axios
          .post(
            "/admin/UserInfo/familyList", {
              user_id: row.id,
            }, {
              token: true,
            }
          )
          .then(async (res) => {
            this.familytableData = res.data.data;
          })
          .catch((error) => {
            console.log(error);
          });
        this.familyModel = true
      },
      guijibegin() {
        this.gjcurrentPage = 1
        this.guijisearch()
      },
      openguiji(row) {
        this.user_value = row.id
        this.guijiModel = true
        this.fwtimes = []
        this.guijibegin()
      },
      async guijisearch() {
        this.loadings = true
        await axios.post("/admin/BrowsingHistory/index", {
            page: this.gjcurrentPage,
            page_count: this.gjpagesize,
            source: 1,
            start_time: this.fwtimes ? this.fwtimes[0] : '',
            end_time: this.fwtimes ? this.fwtimes[1] : '',
            // ip_province: this.formData.sfval,
            // behavior_id: this.formData.xwval,
            // regular: this.formData.mkval,
            user_id: this.user_value
          }, {
            token: true
          })
          .then(response => {
            this.loadings = false
            this.guijitableData = response.data.data.list
            this.gjcount = response.data.data.count
            // this.pageData = response.data.data.pageData
            // this.provinceData = response.data.data.provinceData
            // this.weekData = response.data.data.weekData
          })
          .catch(error => {})
      },
      gjhandleSizeChange(val) {
        let that = this
        that.gjpagesize = val;
        that.guijisearch()
      },
      gjhandleCurrentChange(val) {
        let that = this
        that.gjcurrentPage = val;
        that.guijisearch()
      },
      // 导出数据
      exportExcel() {
        if (!this.exportForm.time) {
          return this.$message({
            type: "error",
            message: "时间不能为空！"
          })
        }
        this.dcing = true
        let url = `/admin/pc/Excel/logReport2Excel`
        let params = ''
        let val = this.exportForm.time
        if (val) {
          params += `&starttime=${val}`
        }
        this.axios.post(url + params, {}, {
          token: true,
          responseType: 'blob'
        }).then(res => {
          this.exportModal = false
          if (res.status == 200) {
            let url = window.URL.createObjectURL(new Blob([res.data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            let filename = new Date().getTime() + '.xlsx';
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
          }
          this.dcing = false
        }).catch(err => {
          this.dcing = false
        })
      },
      getRowKeys(row) {
        return row.id; // id为列表数据的唯一标识
      },
      getdistributionoptions() {
        this.axios.get('/admin/manager/lists', {
          token: true
        }).then(res => {
          this.kfoptions = res.data.data
        })
      },
      deleteItem(row) {
        console.log(row);
      },
      distribution(t) {
        if (this.selectusers.length == 0) return this.$message('请先选择用户')
        this.distributionModal = true
        this.disTypeRadio = t
      },
      distributionFun() {
        if (!this.disForm.kf) return this.$message('请选择客服')
        let ids = this.selectusers.map((a, i) => a.id)
        this.dcing = true
        this.axios.post('/admin/User/allotUser', {
          "type": this.disTypeRadio,
          "allot_type": this.disForm.disTypeRadio,
          "admin_id": this.disForm.kf,
          "search": ids
        }, {
          token: true
        }).then(res => {
          this.dcing = false
          this.distributionModal = false
          if (res.data.code == 200) {
            this.$message.success('操作成功！')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      closefp() {
        this.disForm = {
          disTypeRadio: 1,
          kf: ''
        }
      },
      pushsx(row) {
        this.layout.showLoading()
        this.axios.post(`/admin/User/messageUser?user_id=${row.id}`, {

        }, {
          token: true
        }).then(res => {
          if (res.data.code == 200) {
            sessionStorage.setItem('user_chat_id', res.data.data.chat_id)
            this.layout.slideSelect('cusSer_client_user', ['zxkf', 'cusSer_client_user'])
          }
          this.layout.hideLoading()

        }).catch(err => {
          this.layout.hideLoading()
        })
      }
    },
  };
</script>

<style lang="scss" scoped>
  // .outbox {
  // 	// padding: 10px;
  // }

  .el-dropdown-link {
    cursor: pointer;
    color: #5473E8;
    font-size: 12px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .wrap {
    position: relative;
  }

  .wrap_btn {
    position: absolute;
    top: 40px;
    right: 40px;
    z-index: 1000;
  }

  .itembox {
    max-height: 500px;
    overflow-y: auto;

    .items {
      border-bottom: 1px solid rgb(233, 233, 233);
      padding: 10px;
      margin-bottom: 5px;
    }
  }

  .outbox2 {
    .sl_tits {
      text-align: center;
      padding: 10px;
    }

    .sl_out_b {
      display: flex;
      justify-content: center;
    }

    .sl_boxx {
      border: 1px solid #e1e2e3;

      .conss {
        padding: 15px;
        color: #000;

        p {
          margin-bottom: 5px;
        }
      }

      .xq {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #e1e2e3;
        padding: 10px 15px;
      }
    }
  }

  .dc_btn_b {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 5px;
  }
</style>